import { FC } from 'react';

import { IconProps } from '../../shared/ui';

export const Accept: FC<IconProps> = ({ width = 18, height = 18, fill = '#1BA049', className }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM7.78995 12.2899C8.06995 12.5699 8.52995 12.5599 8.79995 12.2699L13.2199 7.46988C13.4599 7.19988 13.4399 6.78988 13.1799 6.54988C12.9199 6.30988 12.4999 6.31988 12.2599 6.58988L8.26995 10.9299L5.86995 8.52988C5.61995 8.27988 5.19995 8.27988 4.94995 8.52988C4.69995 8.77988 4.69995 9.19988 4.94995 9.44988L7.78995 12.2899Z"
        fill={fill}
      />
    </svg>
  );
};
